export const emptyInputErrorText = 'This field is required.';

export const BAD_RESPONSE = 'bad response';

export const LOGIN_RESULTS = {
  NEED_CONSENT: 'NEED_CONSENT',
};

export const TOS_CONSENT_REQUIRED = 'TOS_CONSENT_REQUIRED';
